module.exports = __webpack_public_path__ + "static/media/Supplementary_Material.3ce0c43f.pdf";